// extracted by mini-css-extract-plugin
export default {"modal":"address-encoding_modal__+tFGu","tabs":"address-encoding_tabs__fD64x","empty":"address-encoding_empty__AthmS","buttons":"address-encoding_buttons__HCpfI"};